module.exports = __webpack_public_path__ + "img/bookmarks.59172713.svg";